<div class="regwall-card" [class.desktop]="isFinnetDesktop()">
  <img class="star" src="/v3/regwallIcon.png" alt="" aria-hidden="true" loading="lazy" />

  <h2 class="title">Analysiere jede Aktie in wenigen Minuten – 100&nbsp;% kostenfrei</h2>

  <button type="button" class="signup-btn" (click)="onSignup()">Jetzt kostenfrei anmelden</button>

  <p class="login-text">
    Bereits einen Account?
    <button type="button" class="login-link" (click)="onLogin()">Hier einloggen</button>
  </p>

  <ul class="features">
    <li class="feature-item">
      <img class="feature-icon" src="/v3/regwallLineUp.svg" alt="" aria-hidden="true" />
      <span>Relevante Meldungen und Katalysatoren</span>
    </li>
    <li class="feature-item">
      <img class="feature-icon" src="/v3/regwallGraphUp.svg" alt="" aria-hidden="true" />
      <span>Kursziele &amp; Thesen der Top-Analysten</span>
    </li>
    <li class="feature-item">
      <img class="feature-icon" src="/v3/regwallCalendar.svg" alt="" aria-hidden="true" />
      <span>Earnings, Guidance &amp; Call im Überblick</span>
    </li>
    <li class="feature-item">
      <img class="feature-icon" src="/v3/regwallShield.svg" alt="" aria-hidden="true" />
      <span>Vergleich mit den Wettbewerbern</span>
    </li>
  </ul>
</div>
